import { Box } from "@mui/material";
import React from "react";
import { DrawerProvider, useDrawerActions } from "../context/DrawerContext";
import ReportsDrawer from "../components/reports/ReportsDrawer";
import { useReportCards } from "../hooks/useReportCards";
import ReportsSection from "../components/reports/ReportsSection";

const ReportsPageContent = () => {
  const { openDrawer } = useDrawerActions();
  const { reports, visibleTemplates, loadingReports, reloadReports } = useReportCards();

  return (
    <>
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        width="100%"
        sx={{
          py: 2.5,
          gap: 2.5,
          minHeight: "100%",
        }}
      >
        <ReportsSection
          handleAddClick={() => openDrawer("reports", "add")}
          reports={reports}
          visibleTemplates={visibleTemplates}
          loadingReports={loadingReports}
          reloadReports={reloadReports}
        />
      </Box>
      <ReportsDrawer visibleTemplates={visibleTemplates} reloadReports={reloadReports} />
    </>
  );
};

/**
 * The provider wraps the page's own tree rather than sitting in App.tsx: App renders one page
 * from a switch, so this page unmounts on tab navigation and the drawer state resets with it.
 * Hoisting the provider would leave a drawer open across a tab round-trip.
 */
const ReportsPage = () => (
  <DrawerProvider>
    <ReportsPageContent />
  </DrawerProvider>
);

export default ReportsPage;
